import React, { Component } from 'react';
// import './ViewSMS.scss';
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import LabelDropdown from "../../../components/Dropdown/Dropdown/DrpDwn";
import { Button } from "semantic-ui-react";
import moment from "moment";
// import Download from "../../../components/Button/DownloadbleButton";
import { MDBDataTable } from "mdbreact";
import {DatePicker, Icon, Spin} from "antd";
import * as actionCreator from "../../../store/Action";
// import * as TableHeader from "../../../store/Reducer/DropDownConst";
import {connect} from "react-redux";
import Cookies from "js-cookie";
import axiosTags from "../../../axios/axios_tag";
import axios from "../../../axios/axios_visitortag";
import * as common from "../../../const/Common/CommonFunc";
// import PieChart from '../../../const/ChartFrame_SMS_Pie';
import apiConfig from "../../../axios/axios_api_services";

const { RangePicker } = DatePicker;

function disabledDate(current) {
  return current && current > moment().endOf("day");
}

class App extends Component {
  state = {
    selected_category: -1,
    category_list: [],
    category_name: "",
    tags: 0,
    corporate_id: "",
    spin_: true,
    spin: false,
    tags_list: [],

    details: [],
    start_date: '',
    end_date: '',
    searchable_startDate: '',
    searchable_endDate: '',
    searchable_tags: '',
    searchable_corporate_id: '',
    sms_count: 0,

    total_visitors: "",
    peak_day_week: "",
    peak_hour_day_startHour: "",
    peak_hour_day_endHour: "",

    qrCheckInCount: "",
    pre_registration: "",
    manual_registration: "",
    data: [],
    visitorsdata: [],
    hostdata: [],
    companiesdata: [],
    branchList: [],
    branch_id: '',
    visitorsColumns: [
      {
        label: 'Full Name',
        field: 'fullName',
        sort: 'asc '
      },
      {
        label: 'Identification',
        field: 'identification',
        sort: 'asc'
      },
    ],
    hostColumns: [
      {
        label: 'Full Name',
        field: 'fullName',
        sort: 'asc '
      },
      // {
      //   label: 'Identification',
      //   field: 'identification',
      //   sort: 'asc'
      // },
    ],
    companiesColumns: [
      {
        label: 'Company Name',
        field: 'companieName',
        sort: 'asc'
      },
    ],

  };

  titleOnChange = name => (e, { value }) => {
    if (name === 'corporate_id') {
      let tagServices = [];
      this.state.details.map((details, index) => {
        if (details.corporateId === value) {
          tagServices = details.services
        }
      });
      this.setState({
        [name]: value,
        tags_list: tagServices,
        tags: 0
      });
    } else {
      this.setState({
        [name]: value
      });
    }
  };

  onChange = async (date, dateString) => {
    if (dateString[0] === "" || dateString[1] === "") {
    } else {
      let start = new Date(dateString[0]).getTime();
      let end = new Date(dateString[1]).getTime();
      await this.setState({
        start_date: start,
        end_date: end,
      });
      // if (this.props.usr_obj.userRoles !== "SYS_ADMIN") {
      //   this.filterHandler();
      // }
    }
  };
  filterHandler = () => {
    let { corporate_id, start_date, end_date,branch_id } = this.state;
    if (this.props.usr_obj.userRoles !== "SYS_ADMIN") {
      corporate_id = this.props.usr_obj.corporates[0].corporateId
    }
    let condition = false;
    corporate_id === '' ? common.notifyMessage("Please select corporate") : condition = true;

    if(condition && branch_id === ''){
      common.notifyMessage("Please select branch");
      return
    }
    let startDate = new Date().setDate(new Date().getDate() - 30);
    let endDate = new Date().setDate(new Date().getDate());

    if (start_date !== "" && end_date !== "") {
      startDate = start_date;
      endDate = end_date;
    }

    if (condition) {
      this.setState({spin: true});
      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };

      axios.get(apiConfig.CORPORATE_WIDGETS_FOR_VISITOR_REPORT({corporateId:corporate_id,startDate:startDate,endDate:endDate,branchId:branch_id}), { headers: headers })
        .then(response => {
          if (response.data.success) {
            this.setState({
              total_visitors: response.data.content.totalNumberOfVisitors,
              peak_day_week: response.data.content.peakDayInDateRangeResponseDTO.day,

              qrCheckInCount: response.data.content.qrCheckInCount,
              pre_registration: response.data.content.registrationStatusCountResponseDTO.preRegistration,
              manual_registration: response.data.content.registrationStatusCountResponseDTO.manualRegistration,
              visitorsdata: response.data.content.top10RegularVisitorsResponseDTOS,

              hostdata: response.data.content.top10RegularHostResponseDTOS,
              companiesdata: response.data.content.top10RegularCompanies,
              peak_hour_day_startHour: response.data.content.peakHourInDateRangeResponseDTO.startHour,
              peak_hour_day_endHour: response.data.content.peakHourInDateRangeResponseDTO.endHour,
            });
          } else {
            common.notifyMessage(response.data.message);
            this.setState({
              data: [],
              visitorsdata: [],
              hostdata: [],
              companiesdata: []
            })
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.filterHandler();
          }
        })
        .finally(fin => {
          this.setState({
            spin: false
          })
        });
    }
  };

  corporateHandler = name => async (e, { value }) => {
    await this.setState({
      [name]: value
    });
    this.getAllBranch(value);
  };

  getAllDetails = () => {
    // this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.get(apiConfig.SERVICES, { headers: headers })
      .then(async response => {
        if (response.data.success) {
          if (response.data.body.length !== 0) {
            await this.setState({
              // corporate_id: response.data.body[0].corporateId,
              details: response.data.body,
            });
            // this.getAllBranch(response.data.body[0].corporateId);
          }
        } else {
          this.setState({
            details: [],
            spin_: false
          });
          this.props.spinnerHandler(false);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDetails();
        }
      })
      .finally(fin => {
        this.setState({spin_: false});
      })
  };
  getAllBranch = (id) => {
    this.setState({spin_: true});
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corporateId = id === undefined ? this.props.usr_obj.corporates[0].corporateId : id;
    axiosTags.get(apiConfig.CORPORATE_BRANCH(corporateId), {headers: headers})
      .then(async response => {
        if (response.data.success) {

          let userRole = this.props.usr_obj.userRoles;
          await this.setState({
            branchList: response.data.branchList,
            // branch_id: response.data.branchList.length !== 0 ? response.data.branchList[0].branchId : 0
            branch_id: userRole === "SYS_ADMIN" ? '': response.data.branchList.length !== 0 ? response.data.branchList[0].branchId : ''
          });

          if(userRole !== "SYS_ADMIN" && response.data.branchList.length !== 0){
            this.filterHandler()
          }
        } else {
          this.setState({branchList: [], branch_id: ''});
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllBranch(id);
        }
      })
      .finally(fin => {
        this.setState({spin_: false});
      })
  };

  componentDidMount() {
    // this.getAllDetails();
    if (this.props.usr_obj.userRoles === "SYS_ADMIN") {
      this.getAllDetails();
    } else {
      let corporate_id = this.props.usr_obj.corporates[0].corporateId;
      this.getAllBranch(corporate_id);
    }
  }

  render() {
    let corporate_options = [];
    let branch_options = [];

    let total_visitors = this.state.total_visitors;
    let peak_day_week = this.state.peak_day_week;
    let qrCheckInCount = this.state.qrCheckInCount;
    let pre_registration = this.state.pre_registration;
    let manual_registration = this.state.manual_registration;
    let peak_hour_day_startHour = this.state.peak_hour_day_startHour;
    let peak_hour_day_endHour = this.state.peak_hour_day_endHour;

    if (this.state.details.length !== 0) {
      this.state.details.map((details, index) => {
        const obj = {
          key: details.corporateId,
          text: details.corporateName,
          value: details.corporateId
        };
        corporate_options.push(obj)
      })
    }
    if (this.state.branchList.length !== 0) {
      this.state.branchList.map((details, index) => {
        const obj = {
          key: details.branchId,
          text: details.name,
          value: details.branchId
        };
        branch_options.push(obj)
      })
    }

    let rows = [];
    let hostrows = [];
    let companiesrows = [];

    if (this.state.visitorsdata.length !== 0) {
      this.state.visitorsdata.map((value, index) => {
        {
          value.lastName !== null ?
            rows.push({
              fullName: value.firstName + " " + value.lastName,
              identification: value.identificationValue

            })
            :
            rows.push({
              fullName: value.firstName + " " + " ",
              identification: value.identificationValue

            })
        }

      })
    }

    if (this.state.hostdata.length !== 0) {
      this.state.hostdata.map((value, index) => {
        {
          value.lastName !== null && value.lastName !== "DEFAULT_USER"?
            hostrows.push({
              fullName: value.firstName + " " + value.lastName,
              // identification: value.identificationValue

            })
            :
            hostrows.push({
              fullName: value.firstName + " " + " ",
              // identification: value.identificationValue

            })

        }

      })
    }

    if (this.state.companiesdata.length !== 0) {
      this.state.companiesdata.map((value, index) => {
        companiesrows.push({
          companieName: value

        })
      })
    }

    let columns = this.state.visitorsColumns;
    let hostcolumns = this.state.hostColumns;
    let companiescolumns = this.state.companiesColumns;

    let data = { columns, rows };
    let hostdata = { columns: hostcolumns, rows: hostrows }
    let companiesdata = { columns: companiescolumns, rows: companiesrows }

    return (
      <div className={"corp-view-sms"}>
        <Spin spinning={this.state.spin} delay={10}
          indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}>
          <div>
            <Row>
              {
                this.props.usr_obj.userRoles === "SYS_ADMIN" ?
                  <Col>
                    <LabelDropdown
                      disabled={this.state.spin_}
                      tagText={"Select Corporate"}
                      placeholder={"Select Corporate"}
                      options={corporate_options}
                      value={this.state.corporate_id}
                      onChange={this.corporateHandler("corporate_id")}
                    />
                  </Col> : null
              }
              <Col>
                <LabelDropdown
                  disabled={this.state.spin_}
                  tagText={"Branch"}
                  placeholder={"Select Branch"}
                  options={branch_options}
                  value={this.state.branch_id}
                  onChange={(e, { value })=>{this.setState({branch_id:value})}}
                />
              </Col>


              <Col>
                <label className={"required-lbll"}>Choose Date Ranges</label>
                <br />
                <RangePicker
                  className={"rangepicker-super-meeting-report_"}
                  size={"mini"}
                  defaultValue={[moment().subtract(30, "days"), moment().subtract(0, "days")]}
                  disabledDate={disabledDate}
                  format="YYYY-MM-DD"
                  onChange={this.onChange}
                  allowClear={false}
                />

              </Col>
              {/*{*/}
                      {/*this.props.usr_obj.userRoles === "SYS_ADMIN" ?*/}
              {/*<Col xs={3}>*/}
                {/*<Button.Group className={"dual-btn-rangepicker-corp-sms-report"}>*/}
                  {/*<Button positive onClick={this.filterHandler}>Search</Button>*/}
                {/*</Button.Group>*/}
              {/*</Col>*/}
              {/*: null*/}
            {/*}*/}
              <Col xs={3}>
                <Button.Group className={"dual-btn-rangepicker-corp-sms-report"}>
                  <Button positive onClick={this.filterHandler}>Search</Button>
                </Button.Group>
              </Col>
            </Row>

          </div>
          <Row>
            <Col md={4}
              className={"un_selected_category"}>
              <div className={"sms-count-wrapper"}>
                <p className={"sms-count-txt"}>Total Visitor Count</p>
                <Row>
                  <Col  className={"success-wrapper"} xs={12}>
                    {/* <span className={"sms-count-green-txt"}>Success </span> */}
                    <p
                      className={"sms-count-value"}>{total_visitors === "" ? "-" : total_visitors.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                  </Col>

                </Row>
                <br />
              </div>
            </Col>

            <Col md={4}
              className={"un_selected_category"}>
              <div className={"sms-count-wrapper"}>
                <p className={"sms-count-txt"}>Peak Day In A Week</p>
                <Row>
                      <Col  className={"success-wrapper"} xs={12}>
                        <p
                          className={"sms-count-value_"}>{`${peak_day_week ? peak_day_week : `-`}`}</p>
                      </Col>
                </Row>
              </div>
            </Col>

            <Col md={4}
              className={"un_selected_category"}>
              <div className={"sms-count-wrapper"}>
                <p className={"sms-count-txt"}>Peak Hour In A Day</p>
                <Row>
                  {
                    peak_hour_day_startHour ?
                      <Col  className={"success-wrapper"} xs={12}>

                        <p
                          className={"sms-count-value_"}>{peak_hour_day_startHour + " - "+peak_hour_day_endHour}</p>
                      </Col>
                      :

                      <Col  className={"success-wrapper"} xs={12}>

                        <p
                          className={"sms-count-value_"}>{" - "}</p>
                      </Col>

                  }
                </Row>

              </div>
            </Col>
          </Row>
          <br></br>
          <Row>
            <Col md={4}
              className={"un_selected_category"}>
              <div className={"sms-count-wrapper"}>
                <Card className="card margin0">
                  <CardHeader>
                    Top 10 Regular Visitors
                        {/* <Download data={this.state.data} filename={"tags-sms-report.csv"} userType={"VIEW_SMS"}/> */}
                  </CardHeader>
                  <CardBody>
                    <MDBDataTable
                      className={"widget-table"}
                      searching={false}
                      paging={false}
                      //   searchLabel={"Search SMS"}
                      responsive
                      responsiveSm
                      responsiveMd
                      responsiveLg
                      responsiveXl
                      // striped={true}
                      bordered
                      hover
                      entries={10}
                      displayEntries={false}
                      data={data} />

                  </CardBody>
                </Card>
              </div>

            </Col>
            <Col md={4}
              className={"un_selected_category"}>
              <div className={"sms-count-wrapper"}>
                <Card className="card margin0">
                  <CardHeader>
                    Top 10 Regular Host
                        {/* <Download data={this.state.data} filename={"tags-sms-report.csv"} userType={"VIEW_SMS"}/> */}
                  </CardHeader>
                  <CardBody>
                    <MDBDataTable
                      className={"widget-table"}
                      searching={false}
                      paging={false}
                      //   searchLabel={"Search SMS"}
                      responsive
                      responsiveSm
                      responsiveMd
                      responsiveLg
                      responsiveXl
                      // striped={true}
                      bordered
                      hover
                      entries={10}
                      displayEntries={false}
                      data={hostdata} />

                  </CardBody>
                </Card>
              </div>

            </Col>
            <Col md={4}
              className={"un_selected_category"}>
              <div className={"sms-count-wrapper"}>
                <Card className="card margin0">
                  <CardHeader>
                    Top 10 Regular Company
                        {/* <Download data={this.state.data} filename={"tags-sms-report.csv"} userType={"VIEW_SMS"}/> */}
                  </CardHeader>
                  <CardBody>
                    <MDBDataTable
                      className={"widget-table"}
                      searching={false}
                      paging={false}
                      //   searchLabel={"Search SMS"}
                      responsive
                      responsiveSm
                      responsiveMd
                      responsiveLg
                      responsiveXl
                      // striped={true}
                      bordered
                      hover
                      entries={10}
                      displayEntries={false}
                      data={companiesdata} />

                  </CardBody>
                </Card>
              </div>

            </Col>
          </Row>
          <br></br>
          <Row>
            <Col md={6}
              className={"un_selected_category"}>
              <div className={"sms-count-wrapper"}>
                <p className={"sms-count-txt"}>QR Check In Visitor Count</p>
                <Row>
                  <Col style={{ marginLeft: "8vw" }} className={"success-wrapper"} xs={7}>
                    <p
                      className={"sms-count-value"}>{qrCheckInCount === "" ? "-" : qrCheckInCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                  </Col>
                </Row>
                <br/>
              </div>
            </Col>

            <Col md={6}
              className={"un_selected_category"}>
              <div className={"sms-count-wrapper"}>
                <p className={"sms-count-txt"}>Pre-Registration VS Manual Registration</p>
                <Row>
                  <Col style={{ marginLeft: "1.5vw" }} className={"success-wrapper"} xs={5}>
                    <p
                      className={"sms-count-value"}>{pre_registration === "" ? "-" : pre_registration.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                  </Col>&nbsp;&nbsp;
                      <Col style={{ marginLeft: "3vw" }} className={"success-wrapper"} xs={5}>
                        <p
                          className={"sms-count-value"}>{manual_registration === "" ? "-" : manual_registration.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                  </Col>
                </Row>
                <br/>

              </div>
            </Col>

          </Row>
          <br/>
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  visitors: state.viewAllCheckIN.visitors,
  checkInVisitors: state.viewAllCheckIN.checkInVisitors,
  historyColumns: state.viewAllCheckIN.historyColumns,
  column: state.viewAllCheckIN.column,

  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
